// import React, { useState } from "react";
// import { Check, Star, Globe, MessageSquare, Heart, Crown, Plus, Minus } from 'lucide-react';
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";

// const EditPricing = () => {
//   const [activeTab, setActiveTab] = useState(0);
//   const navigate = useNavigate()

//   // All pricing plans state
//   const [plans, setPlans] = useState([
//     {
//       name: 'Free Basic',
//       duration: '15 Days',
//       visibility: 'Standard',
//       features: [
//         'Profile creation',
//         '1 proposal per day',
//         'Limited filters',
//         'Email alerts'
//       ],
//       localPrice: 'Free',
//       overseasPrice: 'Free',
//       icon: Heart,
//       color: 'from-gray-400 to-gray-600',
//       popular: false
//     },
//     {
//       name: 'Verified Standard',
//       duration: '2 months',
//       visibility: 'Standard',
//       features: [
//         'Verified badge',
//         '3 daily proposals',
//         'All basic features',
//         'Priority support'
//       ],
//       localPrice: '4000',
//       overseasPrice: '50.00',
//       icon: Check,
//       color: 'from-blue-500 to-blue-700',
//       popular: false
//     },
//     {
//       name: 'Premium Match',
//       duration: '4 months',
//       visibility: 'Standard + Limited Featured',
//       features: [
//         'All Standard features',
//         '5 daily proposals',
//         'Video intro profile',
//         'WhatsApp support'
//       ],
//       localPrice: '7500',
//       overseasPrice: '75.00',
//       icon: Star,
//       color: 'from-purple-500 to-purple-700',
//       popular: true
//     },
//     {
//       name: 'Elite Sponsored',
//       duration: '6 months',
//       visibility: 'Limited Featured + Global Visibility',
//       features: [
//         '7 daily proposals',
//         'Profile in global list',
//         'Direct inbox access',
//         'Top search ranking',
//         'WhatsApp support',
//         'Exciting features coming'
//       ],
//       localPrice: '12000',
//       overseasPrice: '95.00',
//       icon: Crown,
//       color: 'from-yellow-400 via-orange-500 to-red-500',
//       popular: false
//     }
//   ]);

//   const handlePlanChange = (planIndex, field, value) => {
//     const updatedPlans = [...plans];
//     updatedPlans[planIndex] = { ...updatedPlans[planIndex], [field]: value };
//     setPlans(updatedPlans);
//   };

//   const handleFeatureChange = (planIndex, featureIndex, value) => {
//     const updatedPlans = [...plans];
//     const updatedFeatures = [...updatedPlans[planIndex].features];
//     updatedFeatures[featureIndex] = value;
//     updatedPlans[planIndex] = { ...updatedPlans[planIndex], features: updatedFeatures };
//     setPlans(updatedPlans);
//   };

//   const addFeature = (planIndex) => {
//     const updatedPlans = [...plans];
//     updatedPlans[planIndex] = {
//       ...updatedPlans[planIndex],
//       features: [...updatedPlans[planIndex].features, ""]
//     };
//     setPlans(updatedPlans);
//   };

//   const removeFeature = (planIndex, featureIndex) => {
//     const updatedPlans = [...plans];
//     updatedPlans[planIndex] = {
//       ...updatedPlans[planIndex],
//       features: updatedPlans[planIndex].features.filter((_, i) => i !== featureIndex)
//     };
//     setPlans(updatedPlans);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Updated Plans:", plans);
//     // Send the updated plans to your backend API here
//     alert("Pricing plans updated successfully!");
//   };

//   const currentPlan = plans[activeTab];

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 py-8 px-4">
//       <div className="max-w-6xl mx-auto">
//         <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
//           {/* Header */}
//           <div className="bg-gradient-to-r from-[#730000] to-red-700 text-white p-6">
//             <h2 className="text-4xl font-bold mb-2">Edit Pricing Plans</h2>
//             <p className="text-red-100">Manage your pricing plans and features</p>
//           </div>

//           {/* Tab Navigation */}
//           <div className="border-b border-gray-200">
//             <div className="flex overflow-x-auto">
//               {plans.map((plan, index) => {
//                 const IconComponent = plan.icon;
//                 return (
//                   <button
//                     key={index}
//                     onClick={() => setActiveTab(index)}
//                     className={`flex items-center gap-3 px-6 py-4 font-medium whitespace-nowrap border-b-2 transition-colors ${activeTab === index
//                       ? 'border-[#730000] text-[#730000] bg-red-50'
//                       : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
//                       }`}
//                   >
//                     <IconComponent className="w-5 h-5" />
//                     {plan.name}
//                     {plan.popular && (
//                       <span className="bg-purple-100 text-purple-600 text-xs px-2 py-1 rounded-full">
//                         Popular
//                       </span>
//                     )}
//                   </button>
//                 );
//               })}
//             </div>
//           </div>

//           {/* Form Content */}
//           <div className="p-8 max-sm:p-4">
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
//               {/* Left Column - Plan Details */}

//               <div className="space-y-6">
//                 <h3 className="text-xl font-bold text-gray-800 mb-4">
//                   Plan Details - {currentPlan.name}
//                 </h3>

//                 {currentPlan.name !== "Free Basic" && (
//                   <div className="space-y-2">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Local Price (PKR)
//                       </label>
//                       <input
//                         type="number"
//                         value={currentPlan.localPrice}
//                         onChange={(e) => handlePlanChange(activeTab, 'localPrice', e.target.value)}
//                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#730000] focus:border-transparent"
//                         placeholder="e.g., 4000 or Free"
//                       />
//                     </div>

//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-2">
//                         Overseas Price (USD)
//                       </label>
//                       <input
//                         type="number"
//                         value={currentPlan.overseasPrice}
//                         onChange={(e) => handlePlanChange(activeTab, 'overseasPrice', e.target.value)}
//                         className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#730000] focus:border-transparent"
//                         placeholder="e.g., 50.00 or Free"
//                       />
//                     </div>
//                   </div>
//                 )}
//                 <div className="space-y-2">

//                   <div className="">
//                     <div className="flex items-center justify-between mb-4">
//                       <h4 className="font-semibold  text-xl text-gray-700">Plan Features</h4>
//                       <button
//                         type="button"
//                         onClick={() => addFeature(activeTab)}
//                         className="flex items-center gap-2 px-3 py-2 bg-green-500 text-white text-sm rounded-lg hover:bg-green-600 transition-colors"
//                       >
//                         <Plus className="w-4 h-4" />
//                         Add Feature
//                       </button>
//                     </div>

//                     <div className="space-y-3 overflow-y-auto">
//                       {currentPlan.features.map((feature, index) => (
//                         <div key={index} className="flex items-center gap-3 bg-white rounded-lg p-0.5">
//                           <div className="flex-1">
//                             <input
//                               value={feature}
//                               onChange={(e) => handleFeatureChange(activeTab, index, e.target.value)}
//                               className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#730000] focus:border-transparent resize-none"
//                               placeholder="Enter feature description"
//                               rows="2"
//                             />
//                           </div>
//                           <button
//                             type="button"
//                             onClick={() => removeFeature(activeTab, index)}
//                             className="p-2 text-red-500 bg-red-50 rounded-lg transition-colors"
//                             title="Remove feature"
//                           >
//                             <Minus className="w-4 h-4" />
//                           </button>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>


//               {/* Right Column - Features */}
//               <div className="mt-8 p-6 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg">
//                 <h4 className="font-semibold text-gray-800 text-2xl mb-4">Preview</h4>
//                 <div className="bg-white rounded-lg shadow-md p-6 max-w-sm">
//                   <div className="text-center mb-4">
//                     <div className={`inline-flex items-center justify-center w-12 h-12 rounded-full bg-gradient-to-r ${currentPlan.color} mb-3`}>
//                       <currentPlan.icon className="w-6 h-6 text-white" />
//                     </div>
//                     <h5 className="text-lg font-bold text-[#730000]">{currentPlan.name}</h5>
//                   </div>

//                   {currentPlan.name !== "Free Basic" && (

//                     <div className="text-center mb-4">
//                       <div className="text-2xl font-bold text-[#730000]">
//                         ₨{currentPlan.localPrice} / ${currentPlan.overseasPrice}
//                       </div>
//                     </div>
//                   )}
//                   <div className="space-y-2">
//                     {currentPlan.features.map((feature, index) => (
//                       <div key={index} className="flex items-start gap-2">
//                         <Check className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
//                         <span className="text-sm text-gray-700">{feature}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Preview Card */}

//             {/* Action Buttons */}
//             <div className="flex items-center justify-end gap-4 mt-8 pt-6 border-t border-gray-200">
//               <button
//                 type="button"
//                 onClick={() => navigate(-1)}
//                 className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 onClick={handleSubmit}
//                 className="px-6 py-3 bg-gradient-to-r from-[#730000] to-red-700 text-white rounded-lg hover:from-red-800 hover:to-red-800 transition-all duration-200 font-medium shadow-lg"
//               >
//                 Save All Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditPricing;



import React, { useState } from "react";
import { Check, Star, Globe, MessageSquare, Heart, Crown, Plus, Minus } from 'lucide-react';

const EditPricing = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [billingRegion, setBillingRegion] = useState('local');

  // All pricing plans state
  const [plans, setPlans] = useState([
    {
      name: 'Free Basic',
      duration: '15 Days',
      visibility: 'Standard',
      features: [
        'Profile creation',
        '1 proposal per day',
        'Limited filters',
        'Email alerts'
      ],
      localPrice: 'Free',
      overseasPrice: 'Free',
      icon: Heart,
      color: 'from-gray-400 to-gray-600',
      popular: false
    },
    {
      name: 'Verified Standard',
      duration: '2 months',
      visibility: 'Standard',
      features: [
        'Verified badge',
        '3 daily proposals',
        'All basic features',
        'Priority support'
      ],
      localPrice: '4000',
      overseasPrice: '50.00',
      icon: Check,
      color: 'from-blue-500 to-blue-700',
      popular: false
    },
    {
      name: 'Premium Match',
      duration: '4 months',
      visibility: 'Standard + Limited Featured',
      features: [
        'All Standard features',
        '5 daily proposals',
        'Video intro profile',
        'WhatsApp support'
      ],
      localPrice: '7500',
      overseasPrice: '75.00',
      icon: Star,
      color: 'from-purple-500 to-purple-700',
      popular: true
    },
    {
      name: 'Elite Sponsored',
      duration: '6 months',
      visibility: 'Limited Featured + Global Visibility',
      features: [
        '7 daily proposals',
        'Profile in global list',
        'Direct inbox access',
        'Top search ranking',
        'WhatsApp support',
        'Exciting features coming'
      ],
      localPrice: '12000',
      overseasPrice: '95.00',
      icon: Crown,
      color: 'from-yellow-400 via-orange-500 to-red-500',
      popular: false
    }
  ]);

  const handlePlanChange = (planIndex, field, value) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex] = { ...updatedPlans[planIndex], [field]: value };
    setPlans(updatedPlans);
  };

  const handleFeatureChange = (planIndex, featureIndex, value) => {
    const updatedPlans = [...plans];
    const updatedFeatures = [...updatedPlans[planIndex].features];
    updatedFeatures[featureIndex] = value;
    updatedPlans[planIndex] = { ...updatedPlans[planIndex], features: updatedFeatures };
    setPlans(updatedPlans);
  };

  const addFeature = (planIndex) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex] = {
      ...updatedPlans[planIndex],
      features: [...updatedPlans[planIndex].features, ""]
    };
    setPlans(updatedPlans);
  };

  const removeFeature = (planIndex, featureIndex) => {
    const updatedPlans = [...plans];
    updatedPlans[planIndex] = {
      ...updatedPlans[planIndex],
      features: updatedPlans[planIndex].features.filter((_, i) => i !== featureIndex)
    };
    setPlans(updatedPlans);
  };

  const formatPrice = (localPrice, overseasPrice) => {
    if (localPrice === 'Free') return 'Free';
    
    if (billingRegion === 'local') {
      return `₨${localPrice}`;
    } else {
      return `$${overseasPrice}`;
    }
  };

  const handleSubmit = () => {
    console.log("Updated Plans:", plans);
    alert("Pricing plans updated successfully!");
  };

  const currentPlan = plans[activeTab];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-[#730000] to-red-700 text-white p-6">
            <h2 className="text-4xl font-bold mb-2">Edit Pricing Plans</h2>
            <p className="text-red-100">Manage your pricing plans and features</p>
          </div>

          {/* Tab Navigation */}
          <div className="border-b border-gray-200">
            <div className="flex overflow-x-auto">
              {plans.map((plan, index) => {
                const IconComponent = plan.icon;
                return (
                  <button
                    key={index}
                    onClick={() => setActiveTab(index)}
                    className={`flex items-center gap-3 px-6 py-4 font-medium whitespace-nowrap border-b-2 transition-colors ${
                      activeTab === index
                        ? 'border-[#730000] text-[#730000] bg-red-50'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <IconComponent className="w-5 h-5" />
                    {plan.name}
                    {plan.popular && (
                      <span className="bg-purple-100 text-purple-600 text-xs px-2 py-1 rounded-full">
                        Popular
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Form Content */}
          <div className="p-8 max-sm:p-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Left Column - Plan Details */}
              <div className="xl:col-span-1 space-y-6">
                <h3 className="text-xl font-bold text-gray-800 mb-4">
                  Plan Details - {currentPlan.name}
                </h3>

                {currentPlan.name !== "Free Basic" && (
                  <div className="space-y-2">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Local Price (PKR)
                      </label>
                      <input
                        type="number"
                        value={currentPlan.localPrice}
                        onChange={(e) => handlePlanChange(activeTab, 'localPrice', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#730000] focus:border-transparent"
                        placeholder="e.g., 4000"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Overseas Price (USD)
                      </label>
                      <input
                        type="number"
                        step="0.01"
                        value={currentPlan.overseasPrice}
                        onChange={(e) => handlePlanChange(activeTab, 'overseasPrice', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#730000] focus:border-transparent"
                        placeholder="e.g., 50.00"
                      />
                    </div>
                  </div>
                )}

                {/* Features Section */}
                <div className="rounded-lg">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="font-semibold text-xl text-gray-700">Features</h4>
                    <button
                      type="button"
                      onClick={() => addFeature(activeTab)}
                      className="flex items-center gap-2 px-3 py-2 bg-green-500 text-white text-sm rounded-lg hover:bg-green-600 transition-colors"
                    >
                      <Plus className="w-4 h-4" />
                      Add Feature
                    </button>
                  </div>

                  <div className="space-y-1 max-h-96 overflow-y-auto">
                    {currentPlan.features.map((feature, index) => (
                      <div key={index} className="flex items-center gap-1 bg-white rounded-lg p-0.5">
                        <div className="flex-1">
                          <input
                            value={feature}
                            onChange={(e) => handleFeatureChange(activeTab, index, e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#730000] focus:border-transparent"
                            placeholder="Enter feature description"
                          />
                        </div>
                        <button
                          type="button"
                          onClick={() => removeFeature(activeTab, index)}
                          className="p-2 text-red-500 bg-red-50 rounded-lg transition-colors"
                          title="Remove feature"
                        >
                          <Minus className="" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Right Column - Preview */}
              <div className="xl:col-span-1">
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-6">
                  <div className="flex items-center justify-between mb-6">
                    <h4 className="font-semibold text-[#730000] text-2xl">Live Preview</h4>
                    
                    {/* Billing Toggle for Preview */}
                    <div className="bg-white p-1 rounded-xl shadow-md border-2 border-[#730000]">
                      <button
                        onClick={() => setBillingRegion('local')}
                        className={`px-4 py-2 rounded-lg font-medium text-sm transition-all duration-300 ${
                          billingRegion === 'local'
                            ? 'bg-[#730000] text-white shadow-lg'
                            : 'text-gray-600 hover:text-[#730000]'
                        }`}
                      >
                        PKR
                      </button>
                      <button
                        onClick={() => setBillingRegion('overseas')}
                        className={`px-4 py-2 rounded-lg font-medium text-sm transition-all duration-300 ${
                          billingRegion === 'overseas'
                            ? 'bg-[#730000] text-white shadow-lg'
                            : 'text-gray-600 hover:text-[#730000]'
                        }`}
                      >
                        USD
                      </button>
                    </div>
                  </div>

                  {/* Actual Preview Card - Matching Original Design */}
                  <div className="flex justify-center ">
                    <div
                      className={`relative bg-white rounded-2xl shadow-xl hover:shadow-[#730000] hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 w-full max-w-sm ${
                        currentPlan.popular ? 'ring-2 ring-purple-500 ' : ''
                      }`}
                    >
                      {/* Popular Badge */}
                      {currentPlan.popular && (
                        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                          <span className="bg-gradient-to-r whitespace-nowrap from-purple-500 to-pink-500 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg">
                            Most Popular
                          </span>
                        </div>
                      )}

                      {/* Card Content */}
                      <div className="p-8">
                        {/* Icon and Title */}
                        <div className="text-center mb-6">
                          <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r ${currentPlan.color} mb-4`}>
                            <currentPlan.icon className="w-8 h-8 text-white" />
                          </div>
                          <h3 className="text-3xl font-bold text-[#730000] mb-2">{currentPlan.name}</h3>
                          <div className="text-gray-600">
                            <p className="text-sm">Access Duration: <span className="font-semibold">{currentPlan.duration}</span></p>
                            <p className="text-sm mt-1">Visibility: <span className="font-semibold">{currentPlan.visibility}</span></p>
                          </div>
                        </div>

                        {/* Price */}
                        <div className="text-center mb-8">
                          <div className="text-4xl font-bold text-[#730000]">
                            {formatPrice(currentPlan.localPrice, currentPlan.overseasPrice)}
                          </div>
                          {currentPlan.localPrice !== 'Free' && (
                            <p className="text-gray-500 text-sm mt-1">per {currentPlan.duration.toLowerCase()}</p>
                          )}
                        </div>

                        {/* Features */}
                        <div className="space-y-4 mb-8">
                          {currentPlan.features.map((feature, featureIndex) => (
                            <div key={featureIndex} className="flex items-start gap-3">
                              <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
                              <span className="text-gray-700 text-sm">{feature}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Preview Info */}
                  <div className="mt-6 text-center">
                    <p className="text-sm text-gray-600 mb-2">
                      Need help choosing the right plan? Our support team is here to help.
                    </p>
                    <div className="flex justify-center items-center gap-4 text-xs text-gray-500">
                      <div className="flex items-center gap-1">
                        <MessageSquare className="w-3 h-3" />
                        24/7 Support
                      </div>
                      <div className="flex items-center gap-1">
                        <Globe className="w-3 h-3" />
                        Global Reach
                      </div>
                      <div className="flex items-center gap-1">
                        <Check className="w-3 h-3" />
                        Verified Profiles
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center justify-end gap-4 mt-8 pt-6 border-t border-gray-200">
              <button
                type="button"
                onClick={() => window.history.back()}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                className="px-6 py-3 bg-gradient-to-r from-[#730000] to-red-700 text-white rounded-lg hover:from-red-800 hover:to-red-800 transition-all duration-200 font-medium shadow-lg"
              >
                Save All Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPricing;